export default __webpack_public_path__ + "static/media/rouzjerbi.6dc1a5eb.png";